import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ToastService} from '@sharedcommon/services/toast.service';
import {UserDto} from '@sharedcommon/rest/identity.restservice';
import {Constants} from '@sharedcommon/util/constants.util';
import {UserService} from '@sharedcommon/services/user.service';
import {FunctionUtils} from '@sharedcommon/util/functions.util';
import {ValidationService} from '@sharedcommon/services/validation.service';
import {NeqAbstractFormViewComponent} from '@sharedcommon/components/validation/abstract-form-view.component';

@Component({
  selector: 'neq-user-preferences',
  templateUrl: './user-preferences.component.html'
})
export class NeqUserPreferencesComponent extends NeqAbstractFormViewComponent implements OnInit {

  @Input() user: UserDto;

  form: FormGroup;
  arrayNbRowByPage = Constants.ARRAY_NB_ROW_BY_PAGE;
  arrayNbTableResult = [1, 2, 3, 4, 5];

  constructor(
    private readonly userService: UserService,
    private readonly toastService: ToastService,
    private readonly translationService: TranslateService,
    validationService: ValidationService
  ) {
    super(validationService);
    this.validationService.init();
  }

  ngOnInit() {
    this.init();
  }

  private init() {
    this.form = new FormGroup({
      nbRowByPage: new FormControl(10, [Validators.required]),
      nbTableResult: new FormControl(3, [Validators.required]),
      resultShowUnit: new FormControl(false, []),
      resultTolerancePercent: new FormControl(undefined, [Validators.pattern(Constants.REGEX_INTEGER_POSITIVE)])
    });
    this.checkInForm(this.form);

    for(const meta of this.userService.getMetas()) {
      switch (meta.key) {
        case Constants.USER_META_NB_ROW_BY_PAGE:
          this.form.get('nbRowByPage').patchValue(Number(meta.value));
          break;
        case Constants.USER_META_NB_TABLE_RESULT:
          this.form.get('nbTableResult').patchValue(Number(meta.value));
          break;
        case Constants.USER_META_RESULT_SHOW_UNIT:
          if (meta.value === 'true') {
            this.form.get('resultShowUnit').patchValue(false);
          } else {
            this.form.get('resultShowUnit').patchValue(true);
          }

          break;
        case Constants.USER_META_RESULT_TOLERANCE_PERCENT:
          this.form.get('resultTolerancePercent').patchValue(Number(meta.value));
          break;
      }
    }
  }

  onFormSubmit() {
    if (this.form.invalid) {
      return;
    }

    this.form.markAsPristine();

    this.userService.saveMeta(Constants.USER_META_NB_ROW_BY_PAGE, String(this.form.get('nbRowByPage').value));
    this.userService.saveMeta(Constants.USER_META_NB_TABLE_RESULT, String(this.form.get('nbTableResult').value));
    this.userService.saveMeta(Constants.USER_META_RESULT_SHOW_UNIT, String(!this.form.get('resultShowUnit').value));

    if (FunctionUtils.isDefined(this.form.get('resultTolerancePercent').value)) {
      this.userService.saveMeta(Constants.USER_META_RESULT_TOLERANCE_PERCENT, this.form.get('resultTolerancePercent').value);
    } else {
      this.userService.saveMeta(Constants.USER_META_RESULT_TOLERANCE_PERCENT, undefined);
    }

    this.toastService.toast(this.translationService.instant('msg.user.preferences.updated'));
  }

  hasFormModifications(): boolean {
    return this.form.dirty;
  }

  getFormGroup(): FormGroup {
    return this.form;
  }
}
